import React from 'react';
import { Link } from 'react-router-dom';
import { useHomeController } from '../controllers/useHomeController.js';
import '../style/Home.css';

function Home() {
    const {
        reconnectData,
        showKickModal,
        setShowKickModal,
        reason,
        handleReconnect
    } = useHomeController();

    return (
        <>
            {showKickModal && (
                <div className="modal-kick-overlay">
                    <div className="modal-kick-content">
                        <h2>Entfernt aus Lobby</h2>
                        <p>{reason}</p>
                        <div className="button-group">
                            <button className="button button-primary" onClick={() => setShowKickModal(false)}>
                                Alles klar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="home-page">
                {/* Hero */}
                <div className="home-hero">
                    <h1 className="home-title">LolQuiz</h1>
                    <p className="home-tagline">Das League of Legends Quiz</p>
                    <div className="home-divider">
                        <span className="home-divider-line" />
                        <span className="home-divider-diamond" />
                        <span className="home-divider-line" />
                    </div>
                </div>

                {/* Reconnect Banner */}
                {reconnectData && (
                    <div className="home-reconnect-banner">
                        <i className="fas fa-rotate-right" />
                        <p>
                            Wiederherstellen als <strong>{reconnectData.userName}</strong> in Lobby <strong>{reconnectData.lobbyCode}</strong>?
                        </p>
                        <button className="button button-primary" onClick={handleReconnect}>
                            Verbinden
                        </button>
                    </div>
                )}

                {/* Action Cards */}
                <div className="home-cards">
                    <Link to="/create" className="home-card home-card--create">
                        <div className="home-card-icon">
                            <i className="fas fa-plus" />
                        </div>
                        <div className="home-card-body">
                            <p className="home-card-title">Lobby erstellen</p>
                            <p className="home-card-desc">Starte dein eigenes Quiz und lade Freunde ein</p>
                        </div>
                    </Link>

                    <Link to="/join" className="home-card home-card--join">
                        <div className="home-card-icon">
                            <i className="fas fa-right-to-bracket" />
                        </div>
                        <div className="home-card-body">
                            <p className="home-card-title">Lobby beitreten</p>
                            <p className="home-card-desc">Tritt einer laufenden Runde mit Code bei</p>
                        </div>
                    </Link>

                    <Link to="/lobbies" className="home-card home-card--browse">
                        <div className="home-card-icon">
                            <i className="fas fa-list" />
                        </div>
                        <div className="home-card-body">
                            <p className="home-card-title">Lobbys durchsuchen</p>
                            <p className="home-card-desc">Alle offenen Lobbys auf einen Blick</p>
                        </div>
                    </Link>
                </div>
            </div>
        </>
    );
}

export default Home;